<template>
  <div class="container">
    <pi-header-search
      id="headerSearch"
      :city="city"
      :showType="isMapShow"
      @change="showTypeChange"
    ></pi-header-search>
    <div v-show="isMapShow == 1 || headerScreenShow">
      <pi-header-screen
        ref="headerScreenTop"
        id="headerScreenTop"
        :class="bannerList.length > 0 ? 'header-screen-fixed' : ''"
        @change="screenChange"
      ></pi-header-screen>
    </div>
    <div
      ref="scrolldiv"
      class="container-flex station-list-container"
      v-show="isMapShow == 2"
      @scroll="bindscrollChange"
    >
      <pi-header-banner
        id="headerBanner"
        @loadingsuccess="bannerLoadingsuccess"
      ></pi-header-banner>
      <pi-header-screen
        v-if="bannerList.length > 0"
        ref="headerScreen"
        id="headerScreen"
        @change="screenChange"
      ></pi-header-screen>
      <pi-home-order-tips
        :orderList="orderList"
        v-if="accountInfo.accountPkId && bannerList.length > 0"
        v-show="isMapShow == 2 && !headerScreenShow"
        :bannerListLength="bannerList.length"
      ></pi-home-order-tips>

      <div class="station-ul">
        <div
          class="station-li"
          v-for="(item, index) in stationList"
          :key="index"
        >
          <pi-station-item
            :item="item"
            @change="collected"
            :index="index"
          ></pi-station-item>
        </div>
        <div v-if="stationList.length == 0" class="no-list-data">
          当前城市暂无充电站
        </div>
        <div class="block-bottom" v-if="stationList.length > 0"></div>
      </div>
    </div>
    <template v-if="isLoadingMap">
      <pi-home-map
        @markerclick="markerClick"
        v-show="isMapShow == 1"
        ref="homeMap"
        :stationList="stationList"
        :mapHeight="mapHeight"
        :latitude="staParam.userLat"
        :longitude="staParam.userLng"
      >
      </pi-home-map>
    </template>
    <pi-home-order-tips
      :orderList="orderList"
      v-if="accountInfo.accountPkId"
      v-show="isMapShow == 1 || headerScreenShow"
    ></pi-home-order-tips>
    <pi-home-nav
      :isMore="isNavMore"
      :isMapShow="isMapShow"
      @location="getLocation"
    ></pi-home-nav>
    <pi-home-new-point :isMore="isNavMore"></pi-home-new-point>
  </div>
</template>

<script>
import AMap from "AMap"; // 引入高德地图
import { mapState } from "vuex";
import wxJsSdk from "@/common/location";
import { getStationList, getUserAccount, getNotPayOrder } from "@/common/api";
import { forStationList } from "@/common/common-data";
import preventBack from "@/common/forbidback";
import headerSearch from "./components/header-search/header-search.vue";
import headerBanner from "./components/header-banner/header-banner.vue";
import headerScreen from "./components/header-screen/header-screen.vue";
import homeOrderTips from "./components/home-order-tips/home-order-tips.vue";
import homeNav from "./components/home-nav/home-nav.vue";
import homeMap from "./components/home-map/home-map.vue";
import homeNewPoint from "./components/home-new-point/home-new-point.vue";
import stationItem from "@/components/pi-station-item/pi-station-item.vue";
export default {
  mixins: [preventBack], //注入禁止返回上一页
  components: {
    [headerSearch.name]: headerSearch,
    [headerBanner.name]: headerBanner,
    [headerScreen.name]: headerScreen,
    [stationItem.name]: stationItem,
    [homeOrderTips.name]: homeOrderTips,
    [homeNav.name]: homeNav,
    [homeMap.name]: homeMap,
    [homeNewPoint.name]: homeNewPoint,
  },
  computed: {
    ...mapState(["app"]),
  },
  data() {
    return {
      isMapShow: 2, // 1 地图  2 列表
      isLoadingMap: false, // 是否可以加载地图
      isGetLocation: false, //是否定位
      isInit: false, // 是否初始化
      mapHeight: "100%",
      stationList: [],
      staParam: {
        distance: null,
        pileStatus: 0,
        speedTypes: [],
        oprTagPkIds: [],
        globalPageIndex: 1,
        globalPageSize: 2000,
        userLat: 22.53332,
        userLng: 113.93041,
        appType: 1,
      },
      accountInfo: {}, // 账户信息
      orderList: [], // 正在进行中的订单
      city: "深圳市",
      searchList: [],
      bannerList: [],
      headerScreenObj: {},
      headerScreenShow: false,
      scrollTop: 0,

      collectedLoading: false,
      triggered: false,
      urlData: null, // 普通链接二维码地址详情
      listLoading: true,
      selectStation: {}, //  地图中选择中的站点
      isNavMore: false, // 桩ID 是否上移，地图中站点弹出来时要向上移
      isMarkerStaItem: {}, // 地图点击的站点
    };
  },
  mounted() {},
  activated() {
    this.getUserAccount();
    if (this.scrollTop > 0) {
      this.$refs.scrolldiv.scrollTop = this.scrollTop;
    }
    let selectCity = this.$common.get("selectCity");
    if (selectCity) {
      this.$common.remove("selectCity");
      this.city = selectCity.name;
      if (this.isMapShow == 1 && this.isLoadingMap) {
        this.$refs.homeMap.setZoomAndCenter(selectCity);
      }
    }
  },
  methods: {
    /**
     * 列表和地图切换
     */
    showTypeChange() {
      this.isMapShow = this.isMapShow == 1 ? 2 : 1;
      this.isNavMore =
        this.isMapShow == 1 && this.isMarkerStaItem.staPkId ? true : false;
      if (this.isMapShow == 1 && !this.isLoadingMap) {
        this.isLoadingMap = true;
      }
    },
    /**
     * 筛选项组件选择后返回的方法
     * @param {*} data
     */
    screenChange(data) {
      if (this.bannerList.length > 0) {
        // 两个组件数据联动
        let dataId = data.id;
        let id = dataId == "headerScreen" ? "headerScreenTop" : "headerScreen";
        let headerScreen = this.$refs[id];
        headerScreen.changeValue(data);
      }
      this.staParam = Object.assign(this.staParam, data);
      this.handleGetStationList();
    },
    /**
     * 检查账户
     */
    async getUserAccount() {
      let ret = await getUserAccount({}, { loading: false });
      if (ret.status === 0 && ret.data && ret.data.length > 0) {
        let account = ret.data[0];
        this.accountInfo = account;
        if (account.accountStatus === 4) {
          // 显示账户异常
          this.$dialog
            .alert({
              message: ret.msg,
              confirmButtonText: "确认",
              confirmButtonColor: "#14CC80",
              closeOnPopstate: true,
            })
            .then(() => {
              wxJsSdk.closeWindow(); //关闭窗口
            });
        } else {
          if (!this.isGetLocation) {
            this.getLocation();
          } else {
            this.handleGetStationList();
          }
          this.getNotPayOrder();
          this.tryGotoRecharge();
        }
      }
    },
    /**
     * 带参数扫码进来
     */
    tryGotoRecharge() {
      let qr = this.$common.get(this.$config.localKeyLogin.qr);
      if (qr) {
        console.log(qr)
        // let data = getScanCodeData(qr);
        if (qr) {
          this.$router.push({
            name: "charge/ready",
            query: qr,
          });
        } else {
          this.$toast("二维码不正确，请重新扫描");
        }
      }
      this.$common.remove(this.$config.localKeyLogin.qr);
    },
    /**
     * 获取定位
     */
    getLocation() {
      if (process.env.NODE_ENV === "production") {
        // console.log("微信定位");
        wxJsSdk.getLocation({
          type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: (res) => {
            this.staParam.userLat = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            this.staParam.userLng = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            this.$common.save("staParam", this.staParam);
            this.handleGetStationList();
            this.isGetLocation = true;
            this.searchCity();
            if (this.isMapShow == 1) {
              this.$refs.homeMap.setZoomAndCenter(this.staParam);
            }
          },
          fail: () => {
            this.handleGetStationList();
            // this.$toast('请允许开启定位功能');
          },
          catch: () => {
            this.handleGetStationList();
          },
        });
      } else {
        this.handleGetStationList();
        this.searchCity();
      }
    },
    /**
     * 请求站点列表
     * @param {} call
     */
    async handleGetStationList(call) {
      this.listLoading = true;
      let ret = await getStationList(this.staParam, { loading: false });
      if (ret.data && ret.data.length > 0) {
        let list = forStationList(ret.data);
        this.stationList = list;
      } else {
        this.stationList = [];
      }
      this.listLoading = false;
      call && call();
    },
    /**
     * 轮播图加载成功
     * @param {*} data
     */
    bannerLoadingsuccess(data) {
      this.bannerList = data;
      if (this.bannerList.length > 0) {
        this.$nextTick(() => {
          let headerScreen = this.$refs.headerScreen;
          this.headerScreenObj.top = headerScreen.$el.offsetTop;
          this.headerScreenObj.height = headerScreen.$el.offsetHeight;
        });
      } else {
        this.headerScreenShow = true;
      }
    },
    /**
     * 收藏点击，组件里已经请求成功
     * @param {*} e
     */
    collected(item) {
      let index = item.index;
      this.stationList[index] = item;
    },
    /**
     * 滚动条滚动时
     * @param {*} e
     */
    bindscrollChange() {
      if (this.bannerList.length > 0) {
        let scrollTop = this.$refs.scrolldiv.scrollTop;
        this.scrollTop = scrollTop;
        if (scrollTop > this.headerScreenObj.top) {
          if (!this.headerScreenShow) {
            this.headerScreenShow = true;
          }
        } else {
          if (this.headerScreenShow) {
            this.headerScreenShow = false;
          }
        }
      }
    },
    /**
     * 获取城市名称
     */
    searchCity() {
      AMap.plugin("AMap.Geocoder", () => {
        var geocoder = new AMap.Geocoder({
          city: "010", //城市设为北京，默认：“全国”
        });
        let lnglat = [this.staParam.userLng, this.staParam.userLat];
        geocoder.getAddress(lnglat, (status, result) => {
          console.log(status, result)
          if (status === "complete" && result.info === "OK") {
            // result为对应的地理位置详细信息
            this.city = result.regeocode.addressComponent.city;
          }
        });
      });
    },
    /**
     * 获取正在进行的订单
     */
    async getNotPayOrder() {
      // 获取正在进行中的订单
      let ret = await getNotPayOrder({}, { loading: false });
      if (ret.status === 0 && ret.data) {
        this.orderList = ret.data || [];
      } else {
        this.orderList = [];
      }
    },
    /**
     * 地图中的站点点击
     */
    markerClick(item) {
      this.isNavMore = item.staPkId ? true : false;
      this.isMarkerStaItem = item;
    },
  },
};
</script>
<style scoped lang="less">
.station-list-container {
  background-color: #efeff4;
  position: relative;
}

.station-list-container .station-ul {
  padding: 0 0.2rem 0rem 0.2rem;
  box-sizing: border-box;
}
.station-list-container .station-ul .station-li {
  margin-top: 0.2rem;
}
.station-list-container .station-ul .station-li:first-child {
  margin-top: 0;
}
.station-list-container .station-ul .block-bottom {
  height: 1.4rem;
}
.header-screen-fixed {
  position: fixed;
  left: 0;
  top: 88rpx;
  width: 100%;
  box-sizing: border-box;
  z-index: 5;
}
</style>